import React from 'react';
import Panel from '../../components/ui/Panel';
import EmptyState from '../../components/ui/EmptyState';
import Tag from '../../components/ui/Tag';
import { CATEGORY } from '../../components/ui/categoryColors';

const AssemblyProgressModule = () => {
  return (
    <Panel title="Assembly Progress" titleStyle="section" accent="purple" level={3} actions={<Tag size="sm" hex={CATEGORY.purple.ink.hex}>Phase 10</Tag>}>
      <EmptyState variant="area" title="Coming in the assembly expansion phase">Daily assembly counts, targets, and progress tracking</EmptyState>
    </Panel>
  );
};

export default AssemblyProgressModule;
